(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["functions-cart-drawer"]) return;
  try {
    
(function () {
  function init() {
    var root = document.querySelector('[data-cart-drawer]');
    if (!root || root.dataset.fnInit) return;
    root.dataset.fnInit = '1';

    var moneyFormat = root.getAttribute('data-money-format') || '\u007B\u007Bamount\u007D\u007D';
    var fsEnabled = root.getAttribute('data-fs-enabled') === 'true';
    var fsThreshold = parseInt(root.getAttribute('data-fs-threshold'), 10) || 0;
    var fsProgressTpl = root.getAttribute('data-fs-progress') || '';
    var fsSuccessTpl = root.getAttribute('data-fs-success') || '';

    var itemsEl = root.querySelector('[data-cart-items]');
    var emptyEl = root.querySelector('[data-cart-empty]');
    var footEl = root.querySelector('[data-cart-foot]');
    var subtotalEl = root.querySelector('[data-cart-subtotal]');
    var countEl = root.querySelector('[data-cart-drawer-count]');
    var fsWrap = root.querySelector('[data-fs-wrap]');
    var fsLabel = root.querySelector('[data-fs-label]');
    var fsFill = root.querySelector('[data-fs-fill]');

    // ---- money formatting (Shopify standard) ----
    function formatWithDelimiters(cents, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(cents) || cents == null) cents = 0;
      var value = (cents / 100).toFixed(precision);
      var parts = value.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var rest = parts[1] ? decimal + parts[1] : '';
      return dollars + rest;
    }
    function money(cents) {
      var m = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
      var key = m ? m[1] : 'amount';
      var val;
      switch (key) {
        case 'amount_no_decimals': val = formatWithDelimiters(cents, 0); break;
        case 'amount_with_comma_separator': val = formatWithDelimiters(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': val = formatWithDelimiters(cents, 0, '.', ','); break;
        case 'amount_with_space_separator': val = formatWithDelimiters(cents, 2, ' ', ','); break;
        case 'amount_with_apostrophe_separator': val = formatWithDelimiters(cents, 2, "'", '.'); break;
        default: val = formatWithDelimiters(cents, 2);
      }
      return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, val);
    }

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function setCounts(n) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
      if (countEl) countEl.textContent = n;
    }

    function renderShipping(total) {
      if (!fsEnabled || !fsWrap || fsThreshold <= 0) { if (fsWrap) fsWrap.hidden = true; return; }
      fsWrap.hidden = false;
      var pct = Math.min(100, Math.round((total / fsThreshold) * 100));
      if (fsFill) fsFill.style.width = pct + '%';
      if (total >= fsThreshold) {
        fsLabel.innerHTML = esc(fsSuccessTpl);
      } else {
        var remaining = '<b>' + money(fsThreshold - total) + '</b>';
        // The amount placeholder in the setting is replaced with the remaining sum.
        fsLabel.innerHTML = esc(fsProgressTpl).replace(/\{\{\s*amount\s*\}\}|\[amount\]/i, remaining);
      }
    }

    function render(cart) {
      if (!cart) return;
      setCounts(cart.item_count);
      renderShipping(cart.total_price);

      if (!cart.items || !cart.items.length) {
        itemsEl.innerHTML = '';
        emptyEl.hidden = false;
        footEl.hidden = true;
        return;
      }
      emptyEl.hidden = true;
      footEl.hidden = false;
      subtotalEl.innerHTML = money(cart.items_subtotal_price);

      itemsEl.innerHTML = cart.items.map(function (item, i) {
        var line = i + 1;
        var img = item.image ? esc(item.image) : (item.featured_image && item.featured_image.url ? esc(item.featured_image.url) : '');
        var sub = [];
        if (item.product_has_only_default_variant === false && item.variant_title) sub.push(esc(item.variant_title));
        if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
          sub.push(esc(item.selling_plan_allocation.selling_plan.name));
        }
        var subHtml = sub.length ? '<span class="fn-cart-drawer__variant">' + sub.join(' · ') + '</span>' : '';
        var thumb = img ? '<img class="fn-cart-drawer__thumb" src="' + img + '" alt="' + esc(item.product_title) + '" width="66" height="80" loading="lazy">' : '<span class="fn-cart-drawer__thumb"></span>';
        return '' +
          '<li class="fn-cart-drawer__item" data-line="' + line + '">' +
            thumb +
            '<div class="fn-cart-drawer__info">' +
              '<a class="fn-cart-drawer__name" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
              subHtml +
              '<div class="fn-cart-drawer__qty">' +
                '<button type="button" data-qty-down aria-label="Menge verringern">−</button>' +
                '<span data-qty>' + item.quantity + '</span>' +
                '<button type="button" data-qty-up aria-label="Menge erhöhen">+</button>' +
              '</div>' +
            '</div>' +
            '<div class="fn-cart-drawer__side">' +
              '<span class="fn-cart-drawer__price">' + money(item.final_line_price) + '</span>' +
              '<button type="button" class="fn-cart-drawer__remove" data-remove>Entfernen</button>' +
            '</div>' +
          '</li>';
      }).join('');
    }

    var lastCart = null;
    function refresh() {
      root.classList.add('is-loading');
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { lastCart = cart; render(cart); })
        .finally(function () { root.classList.remove('is-loading'); });
    }

    function changeLine(line, quantity) {
      root.classList.add('is-loading');
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          lastCart = cart;
          render(cart);
          window.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        })
        .finally(function () { root.classList.remove('is-loading'); });
    }

    // ---- open / close ----
    function open() {
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('fn-cart-locked');
      refresh();
      var closeBtn = root.querySelector('.fn-cart-drawer__close');
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('fn-cart-locked');
    }

    // Intercept the header cart trigger (also fires for the programmatic
    // .click() that functions-product.js runs after add-to-cart).
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-cart-drawer-trigger]');
      if (trigger) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-cart-close]')) { close(); return; }

      var item = e.target.closest('.fn-cart-drawer__item');
      if (!item || !root.contains(item)) return;
      var line = parseInt(item.getAttribute('data-line'), 10);
      var qtyEl = item.querySelector('[data-qty]');
      var qty = parseInt(qtyEl ? qtyEl.textContent : '1', 10);
      if (e.target.closest('[data-qty-up]')) changeLine(line, qty + 1);
      else if (e.target.closest('[data-qty-down]')) changeLine(line, Math.max(0, qty - 1));
      else if (e.target.closest('[data-remove]')) changeLine(line, 0);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    // Keep contents live whenever the cart changes elsewhere.
    window.addEventListener('cart:updated', function (e) {
      if (e.detail) { lastCart = e.detail; render(e.detail); }
      else refresh();
    });

    // Prime counts on load (no fetch needed if header already has the count).
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["functions-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var bar = document.querySelector('[data-fn-sticky-atc]');
    if (!bar) return;
    var root = document.querySelector('[data-functions-product]');
    if (!root) { bar.remove(); return; }
    var form = root.querySelector('form[data-add-to-cart-form]');
    var wraps = Array.prototype.slice.call(root.querySelectorAll('[data-variant-wrap]'));
    if (!wraps.length) { bar.remove(); return; }

    var titleEl = bar.querySelector('[data-sticky-title]');
    var priceEl = bar.querySelector('[data-sticky-price]');
    var select = bar.querySelector('[data-sticky-select]');
    var addBtn = bar.querySelector('[data-sticky-add]');

    function titleOf(w) {
      var t = w.querySelector('.fn-variant__title');
      return t ? t.textContent.trim() : '';
    }

    // Build the dropdown options from the hero packages.
    wraps.forEach(function (w, i) {
      var opt = document.createElement('option');
      opt.value = String(i);
      opt.textContent = titleOf(w);
      select.appendChild(opt);
    });

    function activeIndex() {
      for (var i = 0; i < wraps.length; i++) {
        var card = wraps[i].querySelector('[data-variant-card]');
        if (card && card.getAttribute('aria-checked') === 'true') return i;
      }
      return 0;
    }

    function sync() {
      var i = activeIndex();
      var w = wraps[i];
      var badge = w.querySelector('.fn-variant__badge');
      var badgeTxt = badge && badge.textContent.trim() ? ' · ' + badge.textContent.trim() : '';
      titleEl.textContent = titleOf(w) + badgeTxt;
      priceEl.textContent = w.getAttribute('data-variant-per-unit') || w.getAttribute('data-variant-price') || '';
      if (select.value !== String(i)) select.value = String(i);
    }

    // Keep the bar in sync when a hero package is chosen.
    wraps.forEach(function (w) {
      var card = w.querySelector('[data-variant-card]');
      if (card) card.addEventListener('click', function () { setTimeout(sync, 0); });
    });

    // Changing the sticky dropdown drives the same selection code path.
    select.addEventListener('change', function () {
      var w = wraps[parseInt(select.value, 10)];
      if (!w) return;
      var card = w.querySelector('[data-variant-card]');
      if (card) card.click();
      sync();
    });

    // Reuse the hero form's submit (variant id + quantity already set).
    addBtn.addEventListener('click', function () {
      if (!form) return;
      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });

    // Permanent on the product page.
    bar.classList.add('is-visible');

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
